import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { for: "name" }

import { useValidation } from "vue3-form-validation";
import { useSectors } from "../sector/hooks/useSectors";


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionForm',
  emits: ["validate"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const { sectors, loading: _sectorsLoading } = useSectors();
const { form, hasError, validateFields, resetFields } = useValidation({
  name: {
    $value: "",
    $rules: [(n: string) => !n && ""],
  },
});

__expose({ validateFields, resetFields, hasError });

const submit = () => {
  validateFields().then((input) => {
    emit("validate", input);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("form", {
    autocomplete: "off",
    class: "p-fluid",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("activity.name")), 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _unref(form).name.$value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name.$value) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(form).name.$validate())),
        class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
      }, null, 8, ["modelValue", "class"])
    ])
  ], 32))
}
}

})